module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAC1SURBVDiNrZJhDcIwFIS/RxBQCbOAA6YEC5NQFCwoACfMARKGA+bg+MEjWRhrx+gl96fv8rUvPRhJUiupISNJjaQ+FWj1UpXI7D3T5m7r3ROYpOCz2+fMfJUDEPwsuAf3WHOzk0l6jCCrZZL0LwRgUwKSA92BrgToYmY1UDt0NQgAM+uAHRC//OJykMMGMzumVt0uAXk5r8Bs45MvklRJOgN9CkKmR+/2JgFLQD+paCFjAU58AuLtaKElC7pfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video.png
// module id = +vEQ
// module chunks = 1